import { render, staticRenderFns } from "./BaseCancelButton.vue?vue&type=template&id=59f812cb&scoped=true"
import script from "./BaseCancelButton.vue?vue&type=script&lang=js"
export * from "./BaseCancelButton.vue?vue&type=script&lang=js"
import style0 from "./BaseCancelButton.vue?vue&type=style&index=0&id=59f812cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f812cb",
  null
  
)

export default component.exports